export const TRACKING_SOURCE = 'notification_center';

export const SIMPLE_NOTIFICATION_ACTION = 'SimpleNotificationAction';
export const CONTENT_CHANGE_APPROVED_NOTIFICATION =
  'ContentChangeSuggestionApprovedNotification';

export const NOTIFICATIONS_PATH = '/notifications';
